import React, { Component } from 'react';
import {
  Route,
  Redirect,
  Switch,
  withRouter,
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Modal } from 'semantic-ui-react';

/* eslint-disable import/no-extraneous-dependencies */
import 'remeeting-css/semantic/dist/semantic.min.css';
import Heart from 'remeeting-heartbeat';
/* eslint-enable import/no-extraneous-dependencies */

import Account from './account';
import Customize from './customize';
import Recognitions from './recognitions';
import Recognition from './recognitions/recognition';
import Docs from './docs';
import NavContainer from './nav';
import ConnectedKeys from './keys';
import Status from './status';
import RedirectPage from './redirect';

import ConsoleErrorMessage from './utils/console-error-message';
import { errorType } from './types';

import ProtectedRoute from './protected-route';
import {
  clearError,
  refreshTokenFail,
  setRmiAuth,
} from '../modules/session';

import { determineRemeetingApiBaseUrl } from '../modules/rmi';

/* This is the root component that gets appended to the dom.
   This is important because it is where route urls get defined
   and the components they are meant to render are connected.
   Thus, new components that are meant to be accessed directly
   by a url must be registered here with the url and the component. */

class App extends Component {
  state = {
    heart: null,
  }

  componentWillMount() {
    const { connectedSetRmiAuth } = this.props;
    connectedSetRmiAuth();
  }

  componentDidMount() {
    /**
     * Initializes google analytics
     * include on all pages
     */
    const { connectedClearError, connectedRefreshTokenFail } = this.props;
    const heart = new Heart(60 * 10, // Extend token every 10 minutes
      determineRemeetingApiBaseUrl(window.location.hostname),
      ({ type, payload }) => {
        if (type === 'success') {
          connectedClearError();
        }
        if (type === 'error') {
          connectedRefreshTokenFail(payload);
        }
      });
    heart.start();
    this.setState({ heart });
  }

  componentWillUnmount() {
    const { heart } = this.state;
    heart.stop();
  }

  /**
   * This error modal is for errors extending the session token
   * and thus will not be able to be closed. A user will be shown
   * a Sign In button to click to end the session and start a new
   * one.
   */
  renderErrorModal = () => {
    const { error } = this.props;
    return (
      <Modal
        open={error}
      >
        <Modal.Header>Error</Modal.Header>
        <Modal.Content>
          <ConsoleErrorMessage error={error} />
        </Modal.Content>
      </Modal>
    );
  }

  render() {
    const { error } = this.props;
    return (
      <div className="re is-full-height">
        <NavContainer />
        { error && this.renderErrorModal() }

        <main className="re is-full-height">
          <Switch>
            <ProtectedRoute exact path="/account" component={Account} />
            <ProtectedRoute exact path="/customize" component={Customize} />
            <ProtectedRoute exact path="/recognitions" component={Recognitions} />
            <ProtectedRoute exact path="/recognitions/:recognitionId" component={Recognition} />
            <Route exact path="/docs" component={Docs} />
            <ProtectedRoute exact path="/keys" component={ConnectedKeys} />
            <Route exact path="/status" component={Status} />
            <Route exact path="/signin" component={RedirectPage} />
            { /* As a default, if it doesn't match a specific route, redirect to docs */ }
            <Route exact path="/" component={() => (<Redirect to="/docs" />)} />
            <Route component={() => (<Redirect to="/docs" />)} />
          </Switch>
        </main>
      </div>
    );
  }
}

App.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
  connectedRefreshTokenFail: PropTypes.func.isRequired,
  connectedSetRmiAuth: PropTypes.func.isRequired,
  error: errorType,
};

App.defaultProps = {
  error: undefined,
};

const mapStateToProps = state => ({
  error: state.session.error,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedClearError: clearError,
  connectedRefreshTokenFail: refreshTokenFail,
  connectedSetRmiAuth: setRmiAuth,
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(App));
